import { useEffect, useState } from "react";
import { mapPartnerOffices } from "./mapper";
import type { PartnerOffice } from "./type";

export const usePartnerOffices = () => {
	const [partnerOffices, setPartnerOffices] = useState<PartnerOffice[]>([]);
	const [isLoading, setIsLoading] = useState<boolean>(true);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await fetch("/wp-json/wp/v2/bm_partner_office?per_page=100&order=asc&orderby=title");
				const data = await response.json();
				setPartnerOffices(data.map(mapPartnerOffices));
			} catch (error) {
				console.error("Error fetching partner offices:", error);
			} finally {
				setIsLoading(false);
			}
		};

		fetchData();
	}, []);

	return { partnerOffices, isLoading };
};
